import React, { useState, useEffect } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// import { ComboboxField } from '../../../Components/formElements/ComboboxField';
import Layout from "../../../../Layout/Layout";
import DataTable from "react-data-table-component";
import { currencyFormat, formatDateTime } from "../../../../common/Validations";
import { useNavigate } from "react-router-dom";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useSelector
import CustomerConstants from "../../../../common/CustomerConstants";
import {
  addSalesOrderID,
  getSalesOrderList,
} from "../../../../redux/feature/customer_app/preSalesSlice";
import { SearchField } from "../../../../Components/formElements/SearchField";
import configFromEnv from "../../../../services/configuration";
import Moment from "react-moment";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import MultiColumnFilter from "../../../../Components/Filter/MultiColumnFilter";
import StatisticsContainer from "../../../../Components/Cards/StatisticsCardContainer";
import ItemService from "../../../../services/customer_appCommonService";
import { ChartBarIcon, FunnelIcon } from "@heroicons/react/24/solid";
import TableActions from "../../../smart_construction_app/Customer_V4/Common/TableActions/TableActions";
import AP_AUTOConstants from "../../../../common/AP_AUTOConstants";


const ArSalesOrderList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  localStorage.setItem("menu", "Sales");
  localStorage.setItem("submenu", "Sales Order");

  let preSalesData = useSelector((state) => state?.preSales?.salesOrder); // User Details from Store
  let preSalesTable = useSelector(
    (state) => state?.preSales?.salesOrder?.pagination,
  ); // User Details from Store

  const [data, setData] = useState([]);
  const [isCardVisible, setCardVisible] = useState(true);

  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);

  const [filteredData, setFilteredData] = useState([]);
  const [showStats, setShowStats] = useState(false);
  const [filterShow, setFilterShow] = useState(false);

  useEffect(() => {
    if (!showStats) {
      setFilteredData(preSalesData?.data || []);
    }
  }, [showStats, preSalesData]);

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  const detailedPage = (salesOrderID) => {
    dispatch(addSalesOrderID(salesOrderID));
    navigate(CustomerConstants.SALES_SALES_ORDER_DETAILS);
  };

  const handleCreate = () => {
    navigate(AP_AUTOConstants.AR_CREATE_SO);
  };

  const columns = [
    {
      name: "Document",
      id: "salesDocumentNr",
      // dropDown: true,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPage(row.salesDocumentNr)}
        >
          {row.salesDocumentNr}{" "}
        </button>
      ),
      width: "150px",
    },
    // Conditionally include the 'workflowActionLogs' column
    ...(data?.some((row) => row.workflowActionLogs !== undefined)
      ? [
          {
            name: "Workflow log",
            selector: (row) => row.workflowActionLogs,
            cell: (row) => (
              <div
                style={{ width: "100%" }}
                className="d-flex justify-content-center iconTable"
              >
                <img
                  src="assets/img/newIcons/workflow.png"
                  alt="attachments"
                  style={{ width: "35px" }}
                  className="mt-1"
                  // onClick={() => showStatusInfo(row.workflowActionLogs)}
                />
              </div>
            ),
            sortable: true,
            width: "132px",
          },
        ]
      : []),
    {
      name: "Line Items",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.items)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.items?.length} </span>
        </>
      ),
      width: "100px",
    },
    {
      name: "Attachments",
      selector: (row) => row.attachments,
      cell: (row) => (
        <div
          style={{ width: "100%" }}
          className="d-flex justify-content-center"
        >
          <img
            src="assets/img/newIcons/attached-file.png"
            alt="attachments"
            style={{ width: "25px" }}
            className="mt-1"
          />
        </div>
      ),
      sortable: true,
      width: "130px",
    },
    {
      name: "Version",
      selector: (row) => row.version || "--",
      sortable: true,
      width: "100px",
    },
    {
      name: "Status",
      id: "statusHeader",
      dropDown: true,
      cell: (row) => (
        <>
          <TableStatusField status={row.statusHeader} />
        </>
      ),
      selector: (row) => row.statusHeader || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Date",
      selector: (row) => formatDateTime(row?.salesDocumentDate) || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "SO Value",
      cell: (row) => (
        <span className="numberFormate m-0 p-0 pt-1 fw-bold">
          {currencyFormat(Number(row.salesDocumentValue).toFixed(2))}
        </span>
      ),
      selector: (row) => row.salesDocumentValue || "--",
      sortable: true,
      width: "120px",
    },
    {
      name: "Currency ",
      cell: (row) => (
        <>
          <span className="m-0 p-0 pt-1 fw-bold">{row.currency}</span>
        </>
      ),
      selector: (row) => row.currency || "--",
      sortable: true,
      width: "110px",
    },
    {
      name: "Customer",
      id: "vendorCode",
      dropDown: true,
      selector: (row) => row.vendorCode,
      sortable: true,
      width: "110px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.customerCode} </p>
          <p className="m-0 p-0">{row.customerName} </p>
        </div>
      ),
    },
    {
      name: "Payment Terms",
      selector: (row) => row.paymentTermsCode,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.paymentTerms} </p>
        </div>
      ),
    },
    {
      name: "Inco Terms",
      selector: (row) => row.incoTermsCode,
      sortable: true,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 ">{row.incoTerms} </p>
        </div>
      ),
    },
    {
      name: "Created Date",
      selector: (row) => formatDateTime(row.createdAt),
      cell: (row) => (
        <Moment format={configFromEnv.TIME_FORMATE_WITH_TIME}>
          {row.createdAt}
        </Moment>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "Company",
      cell: (row) => (
        <>
          <span> {row.companyCodeCode} </span>
        </>
      ),
      width: "150px",
    },
    {
      name: "Quotation",
      cell: (row) => (
        <button className="btnInfo">{row.quotationNumber || "--"}</button>
      ),
      width: "150px",
    },

    {
      name: "Qtn Version",
      selector: (row) => row.rfqTechFocalPerson,
      sortable: true,
      width: "120px",
    },
    {
      name: "Action",
      cell: (row) => (
        <TableActions
          actions={[
            {
              label: "Details",
              icon: "bi bi-info-circle",
              iconClass: "text-success",
              bg: "#e6f7ee",
              // onClick: () => showAddProduct("EDIT", row.documentNumber),
            },
            {
              label: "Edit",
              icon: "bi bi-pencil-square",
              iconClass: "text-success",
              bg: "#e6f7ee",
              // onClick: () => showAddProduct("EDIT", row.documentNumber),
            },
            {
              label: "Delete",
              icon: "bi bi-trash",
              iconClass: "text-danger",
              bg: "#fdeaea",
              // onClick: () => deleteMaterial(row),
            },
            {
              label: "More",
              icon: "bi bi-three-dots",
              bg: "#f1f3f5",
              onClick: () => console.log("More", row),
            },
          ]}
        />
      ),
      width: "180px",
    },
  ];

  const lineItemColInfo = [
    {
      name: "Material",
      cell: (row) => <span>{row.materialCode} </span>,
      width: "200px",
    },
    {
      name: "Material Desc",
      cell: (row) => <span>{row.materialDescription} </span>,
      width: "200px",
    },
    {
      name: "Material Group",
      cell: (row) => <span>{row.materialGroup} </span>,
      width: "250px",
    },
    {
      name: "Sales Qty",
      cell: (row) => <span>{row.salesQuantity} </span>,
      width: "250px",
    },
    {
      name: "UOM",
      cell: (row) => <span>{row.orderUnitOfMeasure} </span>,
      width: "250px",
    },
    {
      name: "Unit Price",
      cell: (row) => <span>{row.orderPriceUnit} </span>,
      width: "250px",
    },
    {
      name: "Value",
      cell: (row) => <span>{row.netValue} </span>,
      width: "250px",
    },
    {
      name: "Delivery Date",
      cell: (row) => <span>{row.deliveryDate} </span>,
      width: "250px",
    },
  ];

  const handleFilterData = async (filters) => {
    const obj = {
      queryName: "getARSalesOrderList",
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: filters.length > 0 ? { $and: filters } : {},
    };

    dispatch(getSalesOrderList(obj));
  };

  const columnsForFilter = columns
    .filter((col) => col.id || col.selectorKey)
    .map((col) => ({
      name: col.name,
      selectorKey: col.id || col.selectorKey,
      dropDown: col.dropDown || false,
      range: col.range || false,
      month: col.month || false,
    }));

  // OnClick on lineItem  Data
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Line Item Details");
    setItemLevelModalShow(true);
  };
  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };

  const loadInitialSuuplierData = async () => {
    setData(preSalesData?.data);
  };

  const handlePageChange = (page) => {
    let obj = {
      queryName: "getARSalesOrderList",
      module: "CUSTOMER",
      page: page,
      per_page: getNewPerPage,
    };

    dispatch(getSalesOrderList(obj));
    setData(preSalesData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "getARSalesOrderList",
      module: "CUSTOMER",
      page: page,
      per_page: newPerPage,
    };
    setNewPerPage(newPerPage);
    dispatch(getSalesOrderList(obj));
    setData(preSalesData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "getARSalesOrderList",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getSalesOrderList(obj));
  };

  useEffect(() => {
    loadInitialSuuplierData(); // fetch page 1 of users
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preSalesData]);

  //on page load
  useEffect(() => {
    let obj = {
      queryName: "getARSalesOrderList",
      module: "CUSTOMER",
      page: 1,
      per_page: 10,
    };
    dispatch(getSalesOrderList(obj));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner timesheet">
            <Row>
              <Col xs={12} md={9} lg={9}>
                <h2 className="mainTitle">Sales Order List</h2>
                <p className="subText">View of Sales Order and Status</p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
            </Row>
            <Col xs={12} md={12} lg={12}>
              <Row className="align-items-end justify-content-end">
                <Col xs="auto" className="me-2">
                  <button
                    onClick={() => setShowStats(!showStats)}
                    className="icon-btn"
                  >
                    <ChartBarIcon className="icon-svg" />
                  </button>
                </Col>

                <Col xs="auto" className="me-2">
                  <button
                    onClick={() => setFilterShow(!filterShow)}
                    className="icon-btn"
                  >
                    <FunnelIcon className="icon-svg" />
                  </button>
                </Col>
              </Row>
            </Col>
            {filterShow && (
              <MultiColumnFilter
                columns={columnsForFilter}
                // data={data}
                fetchFunction={ItemService.generateCustomerQuery}
                onFilter={handleFilterData}
                onCancel={() => setFilterShow(false)}
                queryName="getARSalesOrderList"
              />
            )}
            <hr />
            {showStats && (
              <div className="stats-box p-3 mb-3 position-relative">
                <div className="d-flex align-items-center justify-content-between mb-3">
                  <h5 className="m-0">Statistics</h5>
                  <span
                    style={{
                      cursor: "pointer",
                      fontSize: "20px",
                      color: "red",
                    }}
                    onClick={() => setShowStats(false)}
                  >
                    ×
                  </span>
                </div>

                <StatisticsContainer
                  api={ItemService.generateCustomerQuery}
                  keyName="statusHeader"
                  paginatedList={preSalesData?.data || []}
                  showStats={showStats}
                  onFilter={(data) => setFilteredData(data)}
                  queryName="getARSalesOrderList"
                />
              </div>
            )}

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">SO</span>
                    </Col>
                    <Col xs={8} md={3} lg={3}>
                      <span className="headerTitle">Sales Order List</span>
                    
                      <span className="subHeaderTitle">
                        View of Sales Order and Status{" "}
                      </span>
                    </Col>
                      <Col xs={12} md={2} lg={2} className="headerButtonAlign">
                        <Col xs={6} md={6} lg={6}>
                          <button className="btnTable" onClick={handleCreate}>
                            <i className="bi bi-receipt"></i> Create SO
                          </button>
                        </Col>
                      </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          // data={data}
                          data={filteredData}
                          progressPending={preSalesData?.status}
                          paginationRowsPerPageOptions={
                            CustomerConstants.ROW_PER_PAGE
                          }
                          pagination
                          paginationServer
                          paginationTotalRows={preSalesTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          // onSelectedRowsChange={handleRowSelect}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      {/* Item Text  */}
      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />
    </main>
  );
};

export default ArSalesOrderList;
